import { Tooltip } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import type { CategoryNode } from "@/data/category-tree.js";
import { CDN_URL } from "@/theme.js";

interface Props {
  categories: CategoryNode[];
  selection: string;
  onToggle: (id: number) => void;
}

export function SubcategorySelection({ categories, selection, onToggle }: Props) {
  const selected = selection ? selection.split(",") : [];
  const anySelected = selected.length > 0;

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-start",
        gap: 10,
        margin: "8px 0 4px",
      }}
    >
      {categories.map((node, index) => {
        const isSelected = !anySelected || selected.includes(String(node.id));
        const tooltip = !anySelected ? "Show only" : isSelected ? "Hide" : "Show";
        const displayCount = index === 0 && node.children ? node.realCount : node.count;
        const showCheck = anySelected && isSelected;

        return (
          <Tooltip key={node.id} title={`${tooltip} ${node.category}`} placement="bottom">
            <button
              type="button"
              onClick={() => onToggle(node.id)}
              aria-pressed={isSelected}
              style={{
                position: "relative",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 8,
                padding: 8,
                background: isSelected ? "rgba(59,130,246,0.08)" : "rgba(255,255,255,0.02)",
                border: `1px solid ${
                  isSelected ? "rgba(59,130,246,0.45)" : "rgba(255,255,255,0.08)"
                }`,
                borderRadius: 6,
                cursor: "pointer",
                color: isSelected ? "#fff" : "rgba(255,255,255,0.55)",
                fontSize: 13,
                fontWeight: 500,
                transition:
                  "background 180ms ease, border-color 180ms ease, color 180ms ease, transform 180ms ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              <div
                style={{
                  position: "relative",
                  width: 80,
                  height: 80,
                  borderRadius: 4,
                  overflow: "hidden",
                  background: "var(--tn-card)",
                  filter: isSelected ? "none" : "grayscale(0.4) brightness(0.85)",
                  transition: "filter 180ms ease",
                }}
              >
                <img
                  src={CDN_URL + node.thumb}
                  alt={node.category}
                  style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                />
                {showCheck && (
                  <div
                    style={{
                      position: "absolute",
                      top: 4,
                      right: 4,
                      width: 20,
                      height: 20,
                      borderRadius: 999,
                      background: "var(--ant-color-primary)",
                      color: "#fff",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 11,
                      boxShadow: "0 2px 8px rgba(0,0,0,0.35)",
                    }}
                  >
                    <CheckOutlined />
                  </div>
                )}
              </div>
              <span style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <span>{node.category}</span>
                <span
                  style={{
                    fontSize: 11,
                    color: "rgba(255,255,255,0.4)",
                    fontWeight: 400,
                  }}
                >
                  {Number(displayCount ?? 0).toLocaleString()}
                </span>
              </span>
            </button>
          </Tooltip>
        );
      })}
    </div>
  );
}
